import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { PozoAguaSubterraneaSchema } from "../data/PozoAguaSubterraneaSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import PointField from "./controls/PointField";
import { isInvalid } from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import QuestionField from "./controls/QuestionField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

export function PozoAguaSubterraneaForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  unidadCaudalMedio,
  unidadCaudalPico,
  unidadProfundidad,
  disabled,
}) {
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={PozoAguaSubterraneaSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(pozoAguaSubterraneaForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("pozoAguaSubterraneaForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <PointField
                id="pozoAguaSubterranea_ubicacion"
                name="ubicacion"
                label={t("pozoAguaSubterranea.ubicacion")}
                value={pozoAguaSubterraneaForm.values?.ubicacion}
                onChange={(event) =>
                  pozoAguaSubterraneaForm.handleChange(event)
                }
                isInvalid={isInvalid("ubicacion", pozoAguaSubterraneaForm)}
                error={t(pozoAguaSubterraneaForm.errors.ubicacion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="pozoAguaSubterranea_caudalMedio"
                name="caudalMedio"
                label={t("pozoAguaSubterranea.caudalMedio")}
                value={pozoAguaSubterraneaForm.values?.caudalMedio}
                onChange={(event) =>
                  pozoAguaSubterraneaForm.handleChange(event)
                }
                unit={unidadCaudalMedio}
                isInvalid={isInvalid("caudalMedio", pozoAguaSubterraneaForm)}
                error={t(pozoAguaSubterraneaForm.errors.caudalMedio)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="pozoAguaSubterranea_caudalPico"
                name="caudalPico"
                label={t("pozoAguaSubterranea.caudalPico")}
                value={pozoAguaSubterraneaForm.values?.caudalPico}
                onChange={(event) =>
                  pozoAguaSubterraneaForm.handleChange(event)
                }
                unit={unidadCaudalPico}
                isInvalid={isInvalid("caudalPico", pozoAguaSubterraneaForm)}
                error={t(pozoAguaSubterraneaForm.errors.caudalPico)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="pozoAguaSubterranea_profundidad"
                name="profundidad"
                label={t("pozoAguaSubterranea.profundidad")}
                value={pozoAguaSubterraneaForm.values?.profundidad}
                onChange={(event) =>
                  pozoAguaSubterraneaForm.handleChange(event)
                }
                unit={unidadProfundidad}
                isInvalid={isInvalid("profundidad", pozoAguaSubterraneaForm)}
                error={t(pozoAguaSubterraneaForm.errors.profundidad)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <QuestionField
                id="pozoAguaSubterranea_caudalimetroFunciona"
                name="caudalimetroFunciona"
                label={t("pozoAguaSubterranea.caudalimetroFunciona")}
                value={pozoAguaSubterraneaForm.values?.caudalimetroFunciona}
                onChange={(event) =>
                  pozoAguaSubterraneaForm.handleChange(event)
                }
                isInvalid={isInvalid(
                  "caudalimetroFunciona",
                  pozoAguaSubterraneaForm,
                )}
                error={t(pozoAguaSubterraneaForm.errors.caudalimetroFunciona)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("pozoAguaSubterraneaForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("pozoAguaSubterraneaForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("pozoAguaSubterraneaForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    pozoAguaSubterraneaForm.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && (
                  <Button
                    sm
                    variant="default"
                    value={t("pozoAguaSubterraneaForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
